<template>
    <div class="footer-info-text-logo">
        <footer-logo></footer-logo>
    </div>
    <div class="footer-info-text-information">
        <footer-text text="КОНТАКТНАЯ ИНФОРМАЦИЯ"></footer-text>
    </div>
    <div class="footer-info-text-email">
        <footer-text text="Email: secret@raai.org"></footer-text>
    </div>
<!--    <div class="footer-info-text-phone">-->
<!--        <footer-text text="Телефон: +7 (800) 111-11-11"></footer-text>-->
<!--    </div>-->
    <div class="footer-info-text-rights">
        <footer-text text="© Все права защищены 2023"></footer-text>
    </div>
</template>
<script>

import FooterLogo from '@/components/footer/FooterLogo.vue';
import FooterText from '@/components/footer/FooterText.vue';

export default {
    name: 'FooterInfo',
    components: {
        FooterLogo,
        FooterText
    }
}
</script>
